<template>
  <v-container class="px-0 mx-0">
    <v-layout justify-end>
      <v-btn @click="exportExcel" width="150" :loading="loading" class="mt-n3 light--text text-capitalize btn_fnt" color="primary"> <v-icon small class="me-2">mdi-export</v-icon>Export </v-btn>
    </v-layout>
    <div v-show="false">
      <v-data-table :headers="head" :items="freezeDays" id="exportFreeze" hide-default-footer :items-per-page="-1">
        <template v-slot:[`item.last_modified_date`]="{ item }">
          <span v-if="item.last_modified_date != 'Invalid Date'">
            {{ item.last_modified_date | moment("MMM DD YYYY") }}
          </span>
        </template>
        <template v-slot:[`item.isPaused`]="{ item }">
          {{ item.isPaused ? "Paused" : "" }}
        </template>

        <template v-slot:[`item.fromDate`]="{ item }">
          {{ new Date(parseInt(item.fromDate)) | moment("MMM DD YYYY") }}
        </template>
        <template v-slot:[`item.endDate`]="{ item }">
          <span v-if="item.endDate">
            {{ new Date(parseInt(item.endDate)) | moment("MMM DD YYYY") }}
          </span>
        </template>

        <template v-slot:[`item.isActive`]="{ item }">
          <v-checkbox :disabled="true" color="primary" disabled-color="primary" v-model="item.isActive"></v-checkbox>
        </template>
        <template v-slot:item.updatedBy="{ item }">
          <span v-if="item.updatedBy">{{ item.updatedBy.firstnameEn }} {{ item.updatedBy.lastnameEn }}</span>
        </template>
        <template v-slot:item.customer="{ item }">
          <span v-if="item.user">{{ item.user.firstnameEn }} {{ item.user.lastnameEn }}</span>
        </template>
        <template v-slot:item.phone="{ item }">
          <span v-if="item.user">{{ item.user.phone }} </span>
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
import moment from "moment";
import { Utils } from "../../../utils/utils";
export default {
  props: {
    headers: {
      required: true,
    },

    search: {
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      variables: {
        limit: 0,
        skip: 0,
      },
      head: [],
      exportTable: "",
      freezeDays: [],
    };
  },

  created() {
    this.head = this.headers.filter(x => x.value != "action" && x.value != "siNo");
  },

  methods: {
    getAllFreeze() {
      this.loading = true;
      this.$apollo
        .watchQuery({
          query: require("./api/getAllFreeze.graphql"),
          variables: {
            variables: {
              search: "",
              input: { limit: 0, skip: 0 },
            },
          },
        })
        .refetch({
          search: this.search,
          input: {
            limit: 0,
            skip: 0,
          },
        })
        .then(data => {
          this.loading = false;
          if (data.data.getAllFreeze) {
            this.freezeDays = data.data.getAllFreeze.freeze;
            this.totalItems = data.data.getAllFreeze.totalCount;
            setTimeout(() => {
              Utils.htmlToExcel("exportFreeze", "Freeze", false);
              this.loading = false;
            }, 100);
          }
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },

    exportExcel() {
      this.loading = true;
      this.getAllFreeze();
    },
    toTitleCase(str) {
      if (!str) return "";
      return str.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    numberWithCommas(x) {
      if (x)
        return x
          .toFixed(3)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      else return 0;
    },
    dateFormat(date) {
      return moment(date, "MM-DD-YYYY").format("DD-MM-YYYY, h:mm:ss A");
    },
  },
};
</script>
